import React from 'react'; // Import the React library
import ReactDOM from 'react-dom/client'; // Import the ReactDOM library for rendering
import './index.css'; // Import global CSS styles
import App from './App'; // Import the main App component
import reportWebVitals from './reportWebVitals'; // Import the reportWebVitals function

// Create a root DOM node where the React app will be mounted
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the App component into the root DOM node
root.render(
  // Enable StrictMode to help identify potential problems in an application
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Measure performance of the app (optional)
reportWebVitals();
